import { render, staticRenderFns } from "./classfily.vue?vue&type=template&id=e2cb43b4&scoped=true"
import script from "./classfily.vue?vue&type=script&lang=js"
export * from "./classfily.vue?vue&type=script&lang=js"
import style0 from "./classfily.vue?vue&type=style&index=0&id=e2cb43b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cb43b4",
  null
  
)

export default component.exports